import React from 'react';
import clsx from 'clsx';

const VIEW_CENTER = 1620;
const STROKE_WIDTH = 50;
const RING_RADII = [1393.92, 1156.83, 892.47, 621.16] as const;
const RING_STAGGER_SEC = 0.18;
const CORE_RADIUS = 201.34;

export type DevSpottSymbolLoaderSize = 'xs' | 'sm' | 'lg';

interface DevSpottSymbolLoaderProps {
  /** xs — avatar ao lado do balão; sm — bolha thinking; lg — canvas thinking */
  size?: DevSpottSymbolLoaderSize;
  className?: string;
  /** false = marca estática (sem pulsação / glow animado) */
  animated?: boolean;
}

const sizeClass: Record<DevSpottSymbolLoaderSize, string> = {
  xs: 'h-[18px] w-[18px]',
  sm: 'h-11 w-11',
  lg: 'h-44 w-44 max-w-[min(100%,220px)]',
};

/**
 * Símbolo DevSpott (IDV): anéis em grafite claro #8A99A8 (light) / traço claro (dark) e núcleo laranja.
 * Fundo sempre transparente.
 */
const DevSpottSymbolLoader: React.FC<DevSpottSymbolLoaderProps> = ({
  size = 'sm',
  className,
  animated = true,
}) => (
  <svg
    className={clsx(
      sizeClass[size],
      'flex-shrink-0',
      !animated && 'devspott-loader-static',
      className
    )}
    viewBox="0 0 3240 3240"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    {RING_RADII.map((r, index) => (
      <circle
        key={r}
        cx={VIEW_CENTER}
        cy={VIEW_CENTER}
        r={r}
        fill="none"
        strokeWidth={STROKE_WIDTH}
        strokeMiterlimit={10}
        className="devspott-loader-ring stroke-[#8A99A8] dark:stroke-[#f4f6f9]"
        style={
          animated
            ? { animationDelay: `${index * RING_STAGGER_SEC}s` }
            : undefined
        }
      />
    ))}
    <circle
      cx={VIEW_CENTER}
      cy={VIEW_CENTER}
      r={CORE_RADIUS}
      className="devspott-loader-core fill-[#ec6a3c]"
    />
  </svg>
);

export default DevSpottSymbolLoader;
